// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (max-width: 1024px) {
  .jobs-sidebar {
    display: none  !important;
  }
}

@media only screen and (min-width: 1024px) {
  .module-button{
    display:none !important;
  }
}

@font-face {
  font-family: 'Plus Jakarta Sans';
  src: url('/j/fonts/PlusJakartaSans-Regular.ttf');
  font-weight: 400;
}

@font-face {
  font-family: 'Plus Jakarta Sans';
  src: url('/j/fonts/PlusJakartaSans-Regular.ttf');
  font-weight: normal;
}

@font-face {
  font-family: 'Plus Jakarta Sans';
  src: url('/j/fonts/PlusJakartaSans-Medium.ttf');
  font-weight: 500;
}

@font-face {
  font-family: 'Plus Jakarta Sans';
  src: url('/j/fonts/PlusJakartaSans-SemiBold.ttf');
  font-weight: 600;
}

@font-face {
  font-family: 'Plus Jakarta Sans';
  src: url('/j/fonts/PlusJakartaSans-Bold.ttf');
  font-weight: 700;
}

:root {
  --font-plus-jakarta-sans: 'Plus Jakarta Sans';
}

body {
  font-family: var(--font-plus-jakarta-sans), Helvetica, Arial, sans-serif;
}
`, "",{"version":3,"sources":["webpack://./views/onboarding/App.css"],"names":[],"mappings":"AAAA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,gCAAgC;EAChC,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,wEAAwE;AAC1E","sourcesContent":["@media only screen and (max-width: 1024px) {\n  .jobs-sidebar {\n    display: none  !important;\n  }\n}\n\n@media only screen and (min-width: 1024px) {\n  .module-button{\n    display:none !important;\n  }\n}\n\n@font-face {\n  font-family: 'Plus Jakarta Sans';\n  src: url('/j/fonts/PlusJakartaSans-Regular.ttf');\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: 'Plus Jakarta Sans';\n  src: url('/j/fonts/PlusJakartaSans-Regular.ttf');\n  font-weight: normal;\n}\n\n@font-face {\n  font-family: 'Plus Jakarta Sans';\n  src: url('/j/fonts/PlusJakartaSans-Medium.ttf');\n  font-weight: 500;\n}\n\n@font-face {\n  font-family: 'Plus Jakarta Sans';\n  src: url('/j/fonts/PlusJakartaSans-SemiBold.ttf');\n  font-weight: 600;\n}\n\n@font-face {\n  font-family: 'Plus Jakarta Sans';\n  src: url('/j/fonts/PlusJakartaSans-Bold.ttf');\n  font-weight: 700;\n}\n\n:root {\n  --font-plus-jakarta-sans: 'Plus Jakarta Sans';\n}\n\nbody {\n  font-family: var(--font-plus-jakarta-sans), Helvetica, Arial, sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
